<template>
  <div class="Exportblk7imbgan">
    <v-row>
      <v-col class="text-right">
        <!-- <v-btn
          type="button"
          @click="
            exportexcelblk7imbgan(
              tokenexport,
              exportthn,
              exportbln,
              exportps,
              paparnegeriexport
            )
          "
          color="blue white white--text"
        >
          <span class="material-icons">file_download</span>
          {{ $t("muatturun") }} {{ $t("blk7imbgn") }}
        </v-btn> -->
            <download-excel
              :data = "papardatablk7imbgn"
              type="csv"
              name="blk7imbangan.xls"
              >
              <v-btn type="button" color="blue white white--text">
                <span class="material-icons">file_download</span>
                {{ $t("muatturun") }} {{ $t("blk7imbgn") }}
              </v-btn>
            </download-excel>
      </v-col>
    </v-row>
    &nbsp;
    <v-row>
      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="papardatablk7imbgn"
          :items-per-page="10"
          class="elevation-1"
          height="500"
          fixed-header
        >
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
// import i18n from "@/i18n";
// import hidServices from "@/services/lookupField";
// const lookup = new hidServices();
import axios from "../../plugins/axios";
import Vue from 'vue';
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  Name: "Exportblk7imbgan",
  setup() {},
  props: [
    "papardatablk7imbgn",
    "exportthn",
    "exportbln",
    "exportps",
    "paparnegeriexport",
  ],
  mounted() {},
  data: () => ({
    tokenexport: window.localStorage.getItem("tokenexport"),
    databatch: "",
    headers: [
      { text: "Bil", value: "Bil"},
      { text: "HID", value: "HID"},
      { text: "BNO", value: "BNO"},
      { text: "Pusingan", value: "P"},
      { text: "S", value: "S"},
      { text: "NG", value: "NG"},
      { text: "DP", value: "DP"},
      { text: "DB", value: "DB"},
      { text: "BP", value: "BP"},
      { text: "ST", value: "ST"},
      { text: "NOTK", value: "NOTK"},
      { text: "NOIR", value: "NOIR"},
      //{ text: "Tarikh", value: "Tarikh"},
      // { text: "MM", value: "MM"},
      // { text: "YY", value: "YY"},
      // { text: "Minggu", value: "Minggu"},
      // { text: "Tarikh", value: "Tarikh"},
      // { text: "JumBelanjaA", value: "JumBelanjaA"},
      { text: "NOAIR", value: "NOAIR"},
      { text: "INCS9a", value: "JUM9a"},
      { text: "INCS9b", value: "JUM9b"},
      { text: "INCS9c", value: "JUM9c"},
      { text: "INCS9d", value: "JUM9d"},
      { text: "INCS9e", value: "JUM9e"},
      { text: "INCS09", value: "INCS09"},
      { text: "INCS 07/12", value: "INCS07P12"},
      { text: "INCS 09", value: "TOTINCS09"},
      { text: "Jumlah [B]", value: "JUMLAH_B"},
      { text: "[A]", value: "TOT_A"},
      { text: "[B]", value: "TOT_B"},
      { text: "[C]", value: "TOT_C"},
      { text: "Catatan", value: "CATATAN"},
      //{ text: "PKEY", value: "PKEY"},
    ],
  }),
  methods: {
    async exportexcelblk7imbgan(
      tokenexport,
      exportthn,
      exportbln,
      exportps,
      paparnegeriexport
    ) {
      try {
        await axios
          .post(`${process.env.VUE_APP_API_URL}/sec/checksession`, {
            tokenexportsess: window.localStorage.getItem("tokenexport"),
          })
          .then((result) => {
            console.log(result.data.status);
            if (result.data.status) {
              window.open(
                `${process.env.VUE_APP_API_URL}/blk/exportblk7imbgnserverside/${tokenexport}/${exportthn}/${exportbln}/${exportps}/${paparnegeriexport}/`,
                "_blank"
              );
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>